export const DATA_TYPE = {
    TOTALS: 'totals',
    AVERAGES: 'averages',
    BENCHMARKED_TOTALS: 'benchmarkedTotals',
    BENCHMARKED_AVERAGES: 'benchmarkedAverages',
    PER_GAME: 'perGame',
    MATCH: 'match',
    SEASON_AVERAGES: 'seasonAverages'
};
